export default function demoDirective() {
  return {
    template: require('./demo.html'),
    controller: 'DemoController',
    controllerAs: 'demoVM',
    bindToController: true,
    replace: true,
  };
}
